export class LegCostsDto {
  leg_costs_id: number = null;
  flight_request_id: number = null;
  leg_id: string = null;
  cost_type_id: number = null;
  amount: number = null;
  cost_type: string = null;
  cost_description: string = null;
}
